module.exports = __webpack_public_path__ + "img/Message.c3489753.svg";